import OrderArticle, { getTotalPrice } from "../../models/order/OrderArticle";

export default function calculateXthItemYPercentageOffCampaign(
  x: number,
  y: number,
  orderArticles: OrderArticle[],
  priceLineId: number | null,
  articleIds: { [articleId: string]: true | undefined }
) {
  let discountAmount = 0;

  orderArticles = orderArticles
    .filter((orderArticle) => articleIds[orderArticle.article.id])
    .sort(
      (a, b) =>
        getTotalPrice(a, priceLineId, { count: 1, includeOptions: false, includeExtraOrderArticles: false }) -
        getTotalPrice(b, priceLineId, { count: 1, includeOptions: false, includeExtraOrderArticles: false })
    );

  const totalCount = orderArticles.reduce((sum, orderArticle) => {
    return sum + orderArticle.count;
  }, 0);
  // console.log(totalCount);
  const numberOfDiscountedItems = Math.floor(totalCount / x);
  // console.log(numberOfDiscountedItems);
  let numberOfItemsDiscounted = 0;
  // console.log(orderArticles);
  orderArticles.some((orderArticle) => {
    if (numberOfItemsDiscounted + orderArticle.count <= numberOfDiscountedItems) {
      discountAmount +=
        (getTotalPrice(orderArticle, priceLineId, { includeOptions: false, includeExtraOrderArticles: false }) *
          (y ?? 0)) /
        100;
      numberOfItemsDiscounted += orderArticle.count;
      orderArticle.count -= 0;
      return false;
    } else {
      const count = numberOfDiscountedItems - numberOfItemsDiscounted;
      discountAmount +=
        (getTotalPrice(orderArticle, priceLineId, {
          count,
          includeOptions: false,
          includeExtraOrderArticles: false,
        }) *
          (y ?? 0)) /
        100;
      numberOfItemsDiscounted += count;
      orderArticle.count -= count;
      return true;
    }
  });

  let remaining = x * numberOfDiscountedItems - numberOfItemsDiscounted;
  orderArticles.some((orderArticle) => {
    if (remaining <= 0) {
      return true;
    } else {
      const subtract = Math.min(orderArticle.count, remaining);
      orderArticle.count -= subtract;
      remaining -= subtract;
      return false;
    }
  });

  return discountAmount;
}
